import React, { Component } from 'react';
import FlowController from './flow-controller';

import { EventEmitter } from 'events';

const storeConnect = (
  storeMapping: { [string]: (props: Object) => any },
  storesToListen: EventEmitter[] = []
) => TargetComponent => {
  return class extends Component {
    static wrapType = TargetComponent;
    static displayName = `Wrapper(${TargetComponent.name})`;
    queued: Boolean = false;
    changed: Boolean = false;

    constructor(props) {
      super(props);
      this.attrs = [];
      for (var attr in storeMapping) {
        this.attrs.push([attr, storeMapping[attr]]);
      }
      this.state = this.getState({});
      FlowController.addRender(this, props);
    }

    getState(currentState, currentProps = this.props) {
      var res = {};
      let changed = false;
      for (const [attr, func] of this.attrs) {
        const value = func(currentProps);
        if (value !== currentState[attr]) {
          changed = true;
          res[attr] = value;
        }
      }

      return changed ? res : currentState;
    }

    update = () => {
      this.queued = true;
    };

    doUpdate() {
      const state = this.getState(this.state);
      if (this.mounted && state !== this.state) {
        this.setState(state);
      }
    }

    componentDidMount() {
      this.mounted = true;
      for (var store of storesToListen) {
        store.addChangeListener(this.componentStoreUpdate);
      }
    }
    componentWillUnmount() {
      this.mounted = false;
      this.queued = false;
      this.attrs = [];
      FlowController.removeRender(this);
      for (var store of storesToListen) {
        store.removeChangeListener(this.componentStoreUpdate);
      }
    }

    componentStoreUpdate = () => {
      this.queued = true;
    };

    render() {
      return <TargetComponent ref={ref => (this.ref = ref)} {...this.props} {...this.state} />;
    }
  };
};

export default storeConnect;
